/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetCampaignStatsQueryResponse,
  GetCampaignStatsQueryParams,
} from '../../types/GetCampaignStats'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCampaignStats } from '../../clients/getCampaignStats'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCampaignStatsQueryKey = (
  params?: GetCampaignStatsQueryParams
) =>
  [
    { url: '/api/v1/contacts/campaigns/stats/' },
    ...(params ? [params] : []),
  ] as const

export type GetCampaignStatsQueryKey = ReturnType<
  typeof getCampaignStatsQueryKey
>

export function getCampaignStatsQueryOptions(
  params?: GetCampaignStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCampaignStatsQueryKey(params)
  return queryOptions<
    GetCampaignStatsQueryResponse,
    ResponseErrorConfig<Error>,
    GetCampaignStatsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getCampaignStats(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Return aggregate campaign stats for the current user's company.
 * @summary Get aggregate campaign stats
 * {@link /api/v1/contacts/campaigns/stats/}
 */
export function useGetCampaignStats<
  TData = GetCampaignStatsQueryResponse,
  TQueryData = GetCampaignStatsQueryResponse,
  TQueryKey extends QueryKey = GetCampaignStatsQueryKey,
>(
  params?: GetCampaignStatsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCampaignStatsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getCampaignStatsQueryKey(params)

  const query = useQuery(
    {
      ...getCampaignStatsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
